export function windowOpen(url: string): void {
  if (navigator.userAgent.indexOf('GoNativeIOS') > -1) {
    window.location.href = `gonative://window/open?url=${encodeURIComponent(url)}`;
  } else {
    window.open(url, '_self');
  }
}
